<template>
  <div class="analytics">
    <div class="audit-global-range">
      <global-range @change="getPeriod()" />
    </div>

    <div class="sex" v-if="active">
      <div class="sex__item">
        <thema />
        <tonal />
      </div>
      <div class="sex__item">
        <ul class="post-report-wrap">
          <li
            class="post-report-wrap__item"
            v-for="theme in themes.items.filter(it => it.count > 0)"
            :key="theme.title"
          >
            <el-tooltip
              content="Сформировать отчет в Excel"
              placement="top"
              effect="light"
            >
              <el-link
                class="post-report-wrap__item-link"
                :underline="false"
                :href="getPeriod(theme.thematic_id)"
              >
                <div class="in_link-wrap">
                  <i class="far fa-file-excel fa-4x"></i>
                  <span>Сформировать отчет по тематике {{ theme.title }}</span>
                </div>
              </el-link>
            </el-tooltip>
          </li>
        </ul>
        <div class="age__title">
          Количество публикаций: всего - <span class= "blue">{{ themes.count }}</span>, по тематикам -
          <span class= "blue">{{ summ }}</span>
          , без тематики - <span class= "blue"> {{themes.items.filter(it => it.thematic_id == 0)[0].count || 0}}</span>

        </div>
        <ul class="">
          <li
            class="age__title"
            v-for="theme in themes.items.filter(it => it.thematic_id != 0) || []"
            :key="theme.title"
          >
            <span
              >Количество публикаций по тематике {{ theme.title }} -
              <span class= "blue">{{ theme.count }}</span></span
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/*audit component from tabs directory of analytics with charts*/

// components

import Thema from "./components/Thema";
import Tonal from "./components/Tonal.vue";
import GlobalRange from "../../../../../../components/auditPeriodRange/GlobalPeriodRange";

export default {
  name: "Thematics",
  data() {
    return {
      fileDownloadLinkExcel,
    };
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  computed: {
    themes() {
      return this.$store.getters.auditData("Thematics");
    },
    summ() {
      let entries = this.themes.items ? this.themes.items.filter(it => it.thematic_id != 0) : [];
      let sum = entries.reduce(function (sum, elem) {
        return sum + Number(elem.count);
      }, 0);
      return sum;
    },
  },
  methods: {
    getPeriod(id) {
      let thread_id = this.$route.params.threadId;
      let fFrom = this.$store.getters.getGlobalMainPeriod.map((item) =>
        item.replace(" ", " ")
      )[0];
      let fTo = this.$store.getters.getGlobalMainPeriod.map((item) =>
        item.replace(" ", " ")
      )[1];
      return (this.fileDownloadLink = `https://${!window.location.href.includes('test') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/content/posts_excell?thread_id=${thread_id}&from=${fFrom}&to=${fTo}&filter[thematicFilter][0]=${id}&sort[type]=date&sort[order]=desc&filter[repostoption]=whatever&filter[network_id][0]=1&filter[network_id][1]=2&filter[network_id][2]=3&filter[network_id][3]=5&filter[network_id][4]=7&filter[network_id][5]=8&filter[network_id][6]=4`);
    },
  },
  mounted() {
    this.getPeriod();
  },
  components: {
    Thema,
    Tonal,
    GlobalRange,
  },
};
</script>

<style>
.analytics {
  padding-top: 29px;
}

.audit-global-range {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  margin-right: 20px;
}

.sex,
.geo {
  display: flex;
}
.blue{
  color: #409EFF;
}

  @media screen and (max-width: 480px) {
      .sex, .geo {
        display: block;
      }
  }
</style>
